// src/pages/ContactPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import contactImage from '../assets/contact.svg'; // Your beautiful image
import './ContactPage.css'; // Add your styles for the contact page

const ContactPage = () => {
  const navigate = useNavigate();

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-image-container">
          <img 
            src={contactImage} 
            alt="Contact Us" 
            className="contact-image"
          />
        </div>

        {/* Right side - Contact Details */}
        <div className="contact-details">
          <h2>Get In Touch</h2>
          <div className="contact-method">
            <span className="contact-icon">✉️</span>
            <div>
              <h3>Email Us</h3>
              <a href="mailto:connect@echoframeai.in">connect@echoframeai.in</a>
            </div>
          </div>
          
          {/* Optional: Add a button to go back */}
          <button 
            className="back-button"
            onClick={() => navigate('/')}
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;